/**
 * @generated SignedSource<<0f3dd94798061cee0031aa3204e6f866>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type repositoryFilter_softwareCodePage_RepositoriesFilter$data = ReadonlyArray<{
  readonly repositoryId: string | null | undefined;
  readonly repositoryName: string | null | undefined;
  readonly " $fragmentType": "repositoryFilter_softwareCodePage_RepositoriesFilter";
}>;
export type repositoryFilter_softwareCodePage_RepositoriesFilter$key = ReadonlyArray<{
  readonly " $data"?: repositoryFilter_softwareCodePage_RepositoriesFilter$data;
  readonly " $fragmentSpreads": FragmentRefs<"repositoryFilter_softwareCodePage_RepositoriesFilter">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "repositoryFilter_softwareCodePage_RepositoriesFilter",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "repositoryId"
    },
    {
      "kind": "ScalarField",
      "name": "repositoryName"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "42c59540b25c9f05d665526d15195490";

export default node;
